function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var WishlistPageCtrl = /*#__PURE__*/function () {
  WishlistPageCtrl.$inject = ["wishlistService"];

  /* @ngInject */
  function WishlistPageCtrl(wishlistService) {
    _classCallCheck(this, WishlistPageCtrl);

    this.wishlistService = wishlistService;
  }

  _createClass(WishlistPageCtrl, [{
    key: "$onInit",
    value: function $onInit() {
      this.countObj = this.wishlistService.getCountObj();
    }
  }]);

  return WishlistPageCtrl;
}();

export default WishlistPageCtrl;